import { useNavigate } from 'react-router-dom';
import config from '../../config';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden bg-white dark:bg-gray-900">
        <main className="grow">
          {/* Page header */}

          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="max-w-2xl m-auto mt-16">
              <div className="text-center px-4">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-t from-gray-200 to-gray-100 dark:from-gray-700 dark:to-gray-800 mb-4">
                  <svg className="w-5 h-6 fill-current" viewBox="0 0 20 24">
                    <path
                      className="text-gray-500 dark:text-gray-600"
                      d="M10 10.562l9-5-8.514-4.73a1 1 0 00-.972 0L1 5.562l9 5z"
                    />
                    <path
                      className="text-gray-300 dark:text-gray-400"
                      d="M9 12.294l-9-5v10.412a1 1 0 00.514.874L9 23.294v-11z"
                    />
                    <path
                      className="text-gray-400 dark:text-gray-500"
                      d="M11 12.294v11l8.486-4.714a1 1 0 00.514-.874V7.295l-9 4.999z"
                    />
                  </svg>
                </div>
                <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-2">Hmm.. Nu har du kommit fel</h2>
                <div className="mb-6">
                  Den här sidan finns inte, gå{' '}
                  <span
                    onClick={() => navigate(-1)}
                    className="underline cursor-pointer text-gray-700 hover:text-gray-800"
                  >
                    tillbaka
                  </span>{' '}
                  eller gå till{' '}
                  <a href={config.links.landing} className="underline cursor-pointer text-gray-700 hover:text-gray-800">
                    hemsidan
                  </a>
                  .
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PageNotFound;
